/**
 * Shared auth helper functions to prevent circular dependencies
 * This file contains functions used by both auth hooks and error handling
 */
import { logger } from './logger';

/**
 * Clears auth tokens from localStorage
 * This function is used by both useSignOut and error handlers
 */
export function clearLocalAuthTokens(): void {
  // Clear any localStorage tokens
  try {
    localStorage.removeItem('supabase.auth.token');
    localStorage.removeItem('sb-refreshToken');
    localStorage.removeItem('sb-accessToken');
    logger.store('Local auth tokens cleared');
  } catch (error) {
    logger.error('Error clearing local auth tokens:', error);
  }
}